export class LoanRoleApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getLoanRoles(params) {
    return this.#http.get('/LoanRole', { params });
  }

  async getLoanRole({ loanRoleId }) {
    return this.#http.get(`/LoanRole/${loanRoleId}`);
  }

  async createLoanRole(body) {
    return this.#http.post('/LoanRole', body);
  }

  async editLoanRole({ loanRoleId, ...body }) {
    return this.#http.put(`/LoanRole/${loanRoleId}`, body);
  }

  async deleteLoanRole({ loanRoleId }) {
    return this.#http.delete(`/LoanRole/${loanRoleId}`);
  }
}
